import React, { useEffect } from 'react';
import '../../assets/styles/Home.css';
import HOME_0 from './Home_0';
import HOME_1 from './Home_1';
import { HowItWorks, HowWeDoIt } from './Home_3';
import HOME_4 from './Home_4';
import Footer from '../Footer';
import HomeQuestionGenerator from './HomeQuestionGenerator';
import HomeSampleCharts from './HomeSampleCharts';
import HomeBookCharacters from './HomeBookCharacters';
import HomeAchievements from './HomeAchievements';

const Home = () => {

  useEffect(() => {
    const sections = document.querySelectorAll('.home-section-shell');
    if (!sections.length) {
      return undefined;
    }

    sections.forEach((section, index) => {
      if (index === 0) {
        section.classList.add('is-visible');
      }
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px 15% 0px' }
    );

    sections.forEach((section, index) => {
      if (index !== 0) {
        observer.observe(section);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <main className="home-container home-page">
      <section className="home-section-shell home-section-shell-flush">
        <HOME_0 />
      </section>
      <section className="home-section-shell home-section-shell-flush">
        <HOME_1 />
      </section>
      <section className="home-section-shell home-section-shell-flush">
        <HowItWorks />
      </section>
      <section className="home-section-shell home-section-shell-flush">
        <HomeQuestionGenerator />
      </section>
      <section className="home-section-shell home-section-shell-flush">
        <HomeSampleCharts />
      </section>
      <section className="home-section-shell home-section-shell-flush">
        <HowWeDoIt />
      </section>
      <section className="home-section-shell home-section-shell-flush">
        <HomeBookCharacters />
      </section>
      <HomeAchievements />
      <section className="home-section-shell home-section-shell-flush">
        <HOME_4 />
      </section>
      <Footer />
    </main>
  );
};

export default Home;
